import React from 'react'

import { makeStyles } from '@mui/styles'

import { Can } from '~/src/Flags'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '~/src/Lib/Utils'
import emptyAssignees from '~/src/UI/Assets/EmptyAssignees.svg'
import T from '~/src/UI/Shared/Typography'

import { useIAmLead } from '../utils'
import AddStaffPopover from './AddStaffPopover'

const useStyles = makeStyles(theme => ({
  emptyAssigneesContent: {
    marginTop: theme.spacing(1)
  },
  emptyAssigneesSvg: {
    display: 'flex',
    justifyContent: 'center'
  },
  emptyAssigneesText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(-2),
    '& p, button': {
      fontSize: '1rem'
    },
    '& button': {
      fontWeight: 'bold'
    }
  }
}))

const EmptyAssignees = ({
  disabled,
  namePrefix,
  setValues,
  task = EMPTY_OBJECT,
}) => {
  const classes = useStyles()
  const iAmLead = useIAmLead(task)
  const { assignees = EMPTY_ARRAY } = task
  if (assignees?.length) return null
  return (
    <div className={classes.emptyAssigneesContent}>
      <div className={classes.emptyAssigneesSvg}>
        <img src={emptyAssignees} style={{ maxWidth: '100%' }} alt="Empty assignees svg" />
      </div>
      <div className={classes.emptyAssigneesText}>
        <T>No staff member assigned.</T>
        <Can any actions={['change_task', iAmLead]}>
          <AddStaffPopover
            addStaffLabel
            assignees={assignees}
            disabled={disabled}
            namePrefix={namePrefix}
            setValues={setValues}
          />
        </Can>
      </div>
    </div>
  )
}

export default EmptyAssignees
